export default props => {
  return <div className="topic-index">
    游戏圈子……
  </div>;
};